import {
  SEND_NOTICE,
  SEND_NOTICE_SUCCESS,
  SEND_NOTICE_FAILURE,
  GET_NOTICES,
  GET_NOTICES_SUCCESS,
  GET_NOTICES_NEW_LIST_SUCCESS,
  HIDE_NOTICES_LOADER,
  SHOW_NOTICES_LOADER,
  HIDE_NOTICES_DETAILS_LOADER,
  SHOW_NOTICES_DETAILS_LOADER,
  CLEAR_NOTICES_REDUCER,
  GET_UNREAD_NOTICES,
  GET_UNREAD_NOTICES_SUCCESS,
  GET_NOTICE_BY_ID,
  GET_NOTICE_BY_ID_SUCCESS,
  GET_NOTICE_DELIVERY_STATUS,
  GET_NOTICE_DELIVERY_STATUS_SUCCESS,
  CLEAR_NOTICE_DELIVERY_STATUS,
  CLEAR_NOTICES_UNREAD_COUNT,
  SEND_NOTICE_RESPONSE,
  SEND_NOTICE_RESPONSE_SUCCESS,
  GET_NOTICES_HISTORY,
  GET_NOTICE_HISTORY_BY_ID,
  GET_NOTICE_HISTORY_DELIVERY_STATUS,
  SET_NOTICES_HISTORY_FILTERS,
  SET_SELECTED_NOTICE,
  CREATE_NOTIFICATION_WITH_FILTERS,
  CREATE_NOTIFICATION_WITH_FILTERS_SUCCESS,
  CREATE_NOTIFICATION_WITH_FILTERS_FAILURE,
  GET_NOTIFICATION_TARGETS,
  GET_NOTIFICATION_TARGETS_SUCCESS,
  GET_NOTIFICATION_TARGETS_FAILURE,
  GET_NOTIFICATION_FILTER_OPTIONS,
  GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS,
  GET_NOTIFICATION_FILTER_OPTIONS_FAILURE,
  GET_NOTIFICATION_RECEIVERS,
  GET_NOTIFICATION_RECEIVERS_SUCCESS,
  GET_NOTIFICATION_RECEIVERS_FAILURE,
} from 'constants/ActionTypes';

// filter based
// Action functions for createNotificationWithFilters
export const createNotificationWithFilters = (notificationRequest, redirectToSentOnSuccess) => ({
  type: CREATE_NOTIFICATION_WITH_FILTERS,
  payload: { notificationRequest, redirectToSentOnSuccess },
});

export const createNotificationWithFiltersSuccess = () => ({
  type: CREATE_NOTIFICATION_WITH_FILTERS_SUCCESS,
});

export const createNotificationWithFiltersFailure = () => ({
  type: CREATE_NOTIFICATION_WITH_FILTERS_FAILURE,
});

// Action functions for getNotificationTargets
export const getNotificationTargets = (notificationFiltersRequest, then) => ({
  type: GET_NOTIFICATION_TARGETS,
  payload: { notificationFiltersRequest, then },
});

export const getNotificationTargetsSuccess = targets => ({
  type: GET_NOTIFICATION_TARGETS_SUCCESS,
  payload: { targets },
});

export const getNotificationTargetsFailure = () => ({
  type: GET_NOTIFICATION_TARGETS_FAILURE,
});

// Action functions for getNotificationFilterOptions
export const getNotificationFilterOptions = notificationFiltersRequest => ({
  type: GET_NOTIFICATION_FILTER_OPTIONS,
  payload: { notificationFiltersRequest },
});

export const getNotificationFilterOptionsSuccess = filterOptions => ({
  type: GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS,
  payload: { filterOptions },
});

export const getNotificationFilterOptionsFailure = () => ({
  type: GET_NOTIFICATION_FILTER_OPTIONS_FAILURE,
});

// Action functions for getNotificationReceivers
export const getNotificationReceivers = () => ({
  type: GET_NOTIFICATION_RECEIVERS,
});

export const getNotificationReceiversSuccess = receivers => ({
  type: GET_NOTIFICATION_RECEIVERS_SUCCESS,
  payload: { receivers },
});

export const getNotificationReceiversFailure = () => ({
  type: GET_NOTIFICATION_RECEIVERS_FAILURE,
});

// legacy
export const sendNotice = notification => ({
  type: SEND_NOTICE,
  payload: { notification },
});

export const sendNoticeSuccess = () => ({
  type: SEND_NOTICE_SUCCESS,
});

export const sendNoticeFailure = () => ({
  type: SEND_NOTICE_FAILURE,
});

/**
 * Action type to receive notifications.
 * @param filter
 * @param pagination
 * @param page - page type from NOTICES_TAB_TYPES
 * @returns {{type, payload: {filter: *, pagination: *, page: *}}}
 */
export const getNotices = ({ filter, pagination, page }) => ({
  type: GET_NOTICES,
  payload: { filter, pagination, page },
});

export const getNoticesHistory = ({ filter, filters, pagination }) => ({
  type: GET_NOTICES_HISTORY,
  payload: { filter, filters, pagination },
});

export const getNoticesSuccess = ({ entities, pageCount }) => ({
  type: GET_NOTICES_SUCCESS,
  payload: { entities, pageCount },
});

export const getNoticesNewListSuccess = ({ entities, pageCount }) => ({
  type: GET_NOTICES_NEW_LIST_SUCCESS,
  payload: { entities, pageCount },
});

export const getUnreadNotices = () => ({
  type: GET_UNREAD_NOTICES,
});

export const getUnreadNoticesSuccess = count => ({
  type: GET_UNREAD_NOTICES_SUCCESS,
  payload: count,
});

export const getNoticeById = id => ({
  type: GET_NOTICE_BY_ID,
  payload: { id },
});

export const getNoticeHistoryById = id => ({
  type: GET_NOTICE_HISTORY_BY_ID,
  payload: { id },
});

export const getNoticeByIdSuccess = notice => ({
  type: GET_NOTICE_BY_ID_SUCCESS,
  payload: { notice },
});

export const getNoticeDeliveryStatus = id => ({
  type: GET_NOTICE_DELIVERY_STATUS,
  payload: { id },
});

export const getNoticeHistoryDeliveryStatus = id => ({
  type: GET_NOTICE_HISTORY_DELIVERY_STATUS,
  payload: { id },
});

export const getNoticeDeliveryStatusSuccess = data => ({
  type: GET_NOTICE_DELIVERY_STATUS_SUCCESS,
  payload: { data },
});

export const clearNoticeDeliveryStatus = () => ({
  type: CLEAR_NOTICE_DELIVERY_STATUS,
});

export const hideNoticeLoader = () => ({
  type: HIDE_NOTICES_LOADER,
});

export const showNoticeLoader = () => ({
  type: SHOW_NOTICES_LOADER,
});

export const hideNoticeDetailsLoader = () => ({
  type: HIDE_NOTICES_DETAILS_LOADER,
});

export const showNoticeDetailsLoader = () => ({
  type: SHOW_NOTICES_DETAILS_LOADER,
});

export const clearNoticesReducer = () => ({
  type: CLEAR_NOTICES_REDUCER,
});

export const clearNoticesUnreadCount = () => ({
  type: CLEAR_NOTICES_UNREAD_COUNT,
});

export const sendNoticeResponse = (notificationId, response) => ({
  type: SEND_NOTICE_RESPONSE,
  payload: { notificationId, response },
});

export const sendNoticeResponseSuccess = response => ({
  type: SEND_NOTICE_RESPONSE_SUCCESS,
  payload: { response },
});

export const setNoticesHistoryFilters = filters => ({
  type: SET_NOTICES_HISTORY_FILTERS,
  payload: filters,
});

export const setSelectedNotice = selectedNotice => ({
  type: SET_SELECTED_NOTICE,
  payload: selectedNotice,
});
